export const HSE_TILTAK_STATUSES = [
  "planned",
  "started",
  "in_progress",
  "completed",
  "cancelled",
  "on_hold",
];

export const HSE_TILTAK_PRIORITIES = ["low", "medium", "high", "critical"];

export const HSE_TILTAK_TYPES = ["generic", "new_routine", "linked_document"];

export const HSE_TILTAK_CATEGORIES = [
  "safety",
  "quality",
  "environment",
  "procedure",
  "training",
  "maintenance",
  "equipment",
  "communication",
  "other",
];

const OPEN_STATUSES = new Set(["planned", "started", "in_progress", "on_hold"]);

export function defaultTiltakDeadline(days = 14) {
  const date = new Date();
  date.setDate(date.getDate() + Number(days || 14));
  return date.toISOString().slice(0, 10);
}

export function emptyTiltakForm(defaults = {}) {
  return {
    title: defaults.title || "",
    description: "",
    action_type: defaults.action_type || "generic",
    category: defaults.category || "procedure",
    priority: defaults.priority || "medium",
    status: defaults.status || "planned",
    responsible_user_id: defaults.responsible_user_id || "",
    deadline: defaults.deadline || defaultTiltakDeadline(defaults.dueDays),
    hse_event_id: defaults.hse_event_id || "",
    hse_evaluation_id: defaults.hse_evaluation_id || "",
    hse_document_id: defaults.hse_document_id || "",
    estimated_cost: "",
    completion_notes: "",
    requires_approval: defaults.requires_approval === true,
  };
}

export function tiltakFromRecord(record = {}) {
  return {
    ...emptyTiltakForm(),
    id: record.id,
    title: record.title || "",
    description: record.description || "",
    action_type: record.action_type || "generic",
    category: record.category || "procedure",
    priority: record.priority || "medium",
    status: record.status || "planned",
    responsible_user_id: record.responsible_user_id || record.responsible_user?.id || "",
    deadline: (record.deadline || record.due_on || "").toString().slice(0, 10),
    hse_event_id: record.hse_event_id || record.hse_event?.id || "",
    hse_evaluation_id: record.hse_evaluation_id || "",
    hse_document_id: record.hse_document_id || record.hse_document?.id || "",
    estimated_cost: record.estimated_cost || "",
    completion_notes: record.completion_notes || "",
    requires_approval: record.requires_approval === true,
    responsible_user: record.responsible_user || record.assignee || null,
    hse_event: record.hse_event || null,
    hse_document: record.hse_document || null,
    overdue: record.overdue === true,
  };
}

export function toHseActionPayload(form) {
  const blankToNull = (value) => (value === "" || value == null ? null : value);
  const actionType = HSE_TILTAK_TYPES.includes(form.action_type)
    ? form.action_type
    : "generic";
  return {
    title: (form.title || "").trim(),
    description: form.description || "",
    status: form.status || "planned",
    deadline: form.deadline,
    action_type: actionType,
    responsible_user_id: form.responsible_user_id,
    hse_evaluation_id: blankToNull(form.hse_evaluation_id),
    hse_event_id: blankToNull(form.hse_event_id),
    hse_document_id: blankToNull(form.hse_document_id),
    priority: form.priority || "medium",
    category: form.category || "procedure",
  };
}

export function unwrapHseActionResponse(result) {
  if (!result) throw new Error("empty");
  if (result.response?.status >= 400) {
    const errors = result.response.data?.errors;
    throw new Error(Array.isArray(errors) ? errors.join(", ") : result.message || "error");
  }
  if (result.errors) {
    throw new Error(Array.isArray(result.errors) ? result.errors.join(", ") : String(result.errors));
  }
  return result.data || result;
}

export function isTiltakOverdue(item) {
  if (!item) return false;
  if (item.overdue === true) return true;
  if (!item.deadline || !OPEN_STATUSES.has(item.status || "planned")) return false;
  return String(item.deadline).slice(0, 10) < new Date().toISOString().slice(0, 10);
}

export function filterTiltakForPrint(rows, scope) {
  const list = Array.isArray(rows) ? rows : [];
  if (scope === "overdue") return list.filter((row) => isTiltakOverdue(row));
  if (scope === "open") return list.filter((row) => OPEN_STATUSES.has(row.status));
  if (scope === "completed") return list.filter((row) => row.status === "completed");
  return list;
}
